import * as React from "react";
import { Box } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import { TableHead } from "@mui/material";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import { useState, useEffect } from "react";
import { Container } from "reactstrap";
import { getServices, updateServices } from "../../../apiServices/apiServices";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { FaUserCheck, FaUserXmark } from "react-icons/fa6";
import UserActiveSuspendModal from "../Admin/Modal/UserProfile/UserActiveSuspendModal";
import { MdOutlineEdit } from "react-icons/md";
import AdminUpdateUserProfile from "../Admin/Modal/UserProfile/AdminUpdateUserProfile";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator() {
  return (a, b) => -descendingComparator(a, b);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: "name",
    numeric: false,
    disablePadding: true,
    label: "Name",
  },
  {
    id: "email",
    numeric: false,
    disablePadding: true,
    label: "Email",
  },
  {
    id: "phone_number",
    numeric: false,
    disablePadding: false,
    label: "Phone Number",
  },
  {
    id: "user_type",
    numeric: false,
    disablePadding: false,
    label: "User type",
  },
  {
    id: "company_name",
    numeric: false,
    disablePadding: false,
    label: "Company name",
  },
  {
    id: "gst_no",
    numeric: false,
    disablePadding: false,
    label: "GST no",
  },
  {
    id: "created_on",
    numeric: false,
    disablePadding: false,
    label: "Created on",
  },
  {
    id: "status",
    numeric: false,
    disablePadding: false,
    label: "Status",
  },
  {
    id: "actions",
    numeric: true,
    disablePadding: false,
    label: "Actions",
  },
];

function EnhancedTableHead() {
  return (
    <TableHead sx={{ backgroundColor: "#f7e1a3" }}>
      <TableRow>
        {/* <TableCell padding="checkbox" /> */}
        {headCells.map((headCell) => (
          <TableCell
            sx={{
              fontFamily: "poppins",
            }}
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={"normal"}
          >
            <TableSortLabel>{headCell.label}</TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export default function EnhancedTable() {
  const [order] = React.useState("asc");
  const [orderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [isData, setIsData] = useState([]);
  const [dialog, setDialog] = useState({
    active: false,
    suspend: false,
    update: false,
  });
  const [userStatus, setUserStatus] = useState({
    user_id: "",
    isActive: "",
    user_type: "",
    company_name: "",
    gst_no: "",
  });
  const access_token = sessionStorage.getItem("access-token");
  const [gstValid, setGstValid] = useState(true);

  useEffect(() => {
    if (navigator.onLine) {
      fetchUsersList();
    }
  }, [navigator]);

  const fetchUsersList = async () => {
    try {
      const res = await getServices(`/api/user/user_details`, access_token);
      setIsData(res.responseData.rows);
    } catch (error) {
      toast.error(error);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleActiveModal = (user_info) => {
    setDialog({ ...dialog, active: true });
    setUserStatus({
      ...userStatus,
      user_id: user_info.user_id,
      isActive: 1,
    });
  };

  const handleSuspendModal = (user_info) => {
    setDialog({ ...dialog, suspend: true });
    setUserStatus({
      ...userStatus,
      user_id: user_info.user_id,
      isActive: 0,
    });
  };

  const handleUpdateModal = (user_info) => {
    setDialog({ ...dialog, update: true });
    setUserStatus({
      ...userStatus,
      user_type: user_info.user_type ?? "",
      company_name: user_info.company_name ?? "",
      gst_no: user_info.gst_no ?? "",
      user_id: user_info.user_id ?? "",
    });
  };

  const handleSubmit = async () => {
    try {
      const res = await updateServices(
        `/api/user/handle-state/${userStatus.user_id}`,
        access_token,
        {
          state: userStatus.isActive !== 1 ? 2 : 1,
        }
      );

      if (res.responseCode === 200) {
        fetchUsersList();
        setDialog({ ...dialog, active: false, suspend: false });
        toast.success(
          `User ${userStatus.isActive === 1 ? "activated" : "suspended"}..!`
        );
      } else {
        toast.error(res.responseMessage || "Something went wrong");
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const handleUpdateProfile = async (e) => {
    e.preventDefault();

    if (userStatus.user_type == "") {
      alert("Please select a user type.");
      return;
    } else if (userStatus.gst_no && !gstValid) {
      alert("Please enter a valid GST number or remove it");
      return;
    } else {
      try {
        const res = await updateServices(
          `/api/authenticate/update_profile`,
          access_token,
          {
            user_type: userStatus.user_type,
            gst_no: userStatus.gst_no,
            company_name: userStatus.company_name,
            user_id: userStatus.user_id,
          }
        );

        if (res.responseCode === 200) {
          setDialog({ ...dialog, update: false });
          fetchUsersList();
        } else {
          alert(res.responseMessage);
          // toast.error(res.responseMessage);
        }
      } catch (error) {
        toast.error(error);
      }
    }
  };

  return (
    <>
      <Box sx={{ width: "100%" }}>
        {isData ? (
          <Paper sx={{ width: "100%", mb: 2 }}>
            <TableContainer>
              <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle">
                <EnhancedTableHead />
                <TableBody>
                  {isData &&
                  stableSort(isData, getComparator(order, orderBy)) &&
                  Array.isArray(
                    stableSort(isData, getComparator(order, orderBy))
                  )
                    ? stableSort(isData, getComparator(order, orderBy))
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => {
                          const labelId = `enhanced-table-checkbox-${index}`;

                          return (
                            <TableRow
                              hover
                              role="checkbox"
                              tabIndex={-1}
                              key={row.user_id}
                              // sx={{ cursor: "pointer" }}
                              // onClick={() =>
                              //   navigate("/admin/user/profile", {
                              //     state: { user_id: row.user_id },
                              //   })
                              // }
                            >
                              {/* <TableCell padding="checkbox" /> */}
                              <TableCell
                                component="th"
                                id={labelId}
                                scope="row"
                                padding="0 6px 0 6px"
                                sx={{
                                  fontFamily: "poppins",
                                }}
                              >
                                {row.name}
                              </TableCell>
                              <TableCell
                                component="th"
                                id={labelId}
                                scope="row"
                                padding="none"
                                sx={{
                                  fontFamily: "poppins",
                                }}
                              >
                                {row.email}
                              </TableCell>
                              <TableCell
                                sx={{
                                  fontFamily: "poppins",
                                }}
                              >
                                {row.phone}
                              </TableCell>
                              <TableCell
                                sx={{
                                  fontFamily: "poppins",
                                }}
                              >
                                {row.user_type
                                  ? row.user_type == 1
                                    ? "Individual"
                                    : "Corporate"
                                  : "-"}
                              </TableCell>
                              <TableCell
                                sx={{
                                  fontFamily: "poppins",
                                }}
                              >
                                {row.user_type == 2 ? row.company_name : "-"}
                              </TableCell>
                              <TableCell
                                sx={{
                                  fontFamily: "poppins",
                                }}
                              >
                                {row.gst_no ?? "-"}
                              </TableCell>
                              <TableCell
                                sx={{
                                  fontFamily: "poppins",
                                }}
                                // align="right"
                              >
                                {row.registered_on}
                              </TableCell>
                              <TableCell
                                sx={{
                                  fontFamily: "poppins",
                                }}
                                // align="right"
                              >
                                <span
                                  className={`text-xs px-3 py-[2px] rounded-full ${
                                    row.state === 1
                                      ? "text-green-700 bg-green-100"
                                      : "text-red-700 bg-red-100"
                                  }`}
                                >
                                  {row.state === 1 ? "Active" : "Suspended"}
                                </span>
                              </TableCell>
                              <TableCell>
                                <div className="flex justify-end items-center gap-2">
                                  <MdOutlineEdit
                                    title="Update user"
                                    onClick={() => handleUpdateModal(row)}
                                    className="p-2 text-4xl bg-blue-100 text-blue-700 rounded-full border border-blue-700 cursor-pointer"
                                  />

                                  {row.state !== 1 ? (
                                    <FaUserCheck
                                      title="Active"
                                      className="p-2 text-4xl bg-green-100 text-green-700 rounded-full border border-green-700 cursor-pointer"
                                      onClick={() => handleActiveModal(row)}
                                    />
                                  ) : (
                                    <FaUserXmark
                                      title="Suspend"
                                      className="p-2 text-4xl bg-red-100 text-red-700 rounded-full border border-red-700 cursor-pointer"
                                      onClick={() => handleSuspendModal(row)}
                                    />
                                  )}
                                </div>
                              </TableCell>
                            </TableRow>
                          );
                        })
                    : null}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50, 100]}
              component="div"
              count={isData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{
                "& .MuiTablePagination-selectLabel": {
                  fontFamily: "Poppins",
                },
                "& .MuiTablePagination-select": {
                  fontFamily: "Poppins",
                },
                "& .MuiTablePagination-displayedRows": {
                  fontFamily: "Poppins",
                },
              }}
            />
          </Paper>
        ) : (
          <Container className="flex justify-center font-semibold">
            <p>No users found...</p>
          </Container>
        )}
      </Box>
      <UserActiveSuspendModal
        open={dialog.active}
        onClose={() => setDialog({ ...dialog, active: false })}
        userStatus={userStatus}
        handleSubmit={handleSubmit}
      />
      <UserActiveSuspendModal
        open={dialog.suspend}
        onClose={() => setDialog({ ...dialog, suspend: false })}
        userStatus={userStatus}
        handleSubmit={handleSubmit}
      />

      {/* update profile */}
      <AdminUpdateUserProfile
        isModalShow={dialog.update}
        onClose={() => setDialog({ ...dialog, update: false })}
        userStatus={userStatus}
        setUserStatus={setUserStatus}
        handleUpdateProfile={handleUpdateProfile}
        gstValid={gstValid}
        setGstValid={setGstValid}
      />
    </>
  );
}
